import Button from "../components/button/Button";
import Paragraph from "../components/paragraph/Paragraph";
import { ReactComponent as ProfileIlustration } from "../assets/images/profile-ilustration.svg";
import { useMediaQuery } from "react-responsive";
import Link from "../components/Link/Link";
import { useNavigate } from "react-router-dom";
import { ReactComponent as FolderIcon } from "../assets/icons/folder-grid.svg";
import { ReactComponent as PasswordIcon } from "../assets/icons/password.svg";
import { ReactComponent as EmailIcon } from "../assets/icons/email.svg";
import useAuthPersistStore from "../store/authPersistStore";
import { ROUTES } from "../constants/routes";
import { convertFromISO8601 } from "../utils/convertToIso8601";
import { useSubscriptionDetails } from "../hooks/useSubscriptionDetails";
import Spinner from "../components/spinner/Spinner";
import { useMyContent } from "../hooks/useMyContent";
import useLogout from "../hooks/useLogout";
import UserInitials from "../components/user/UserInitials";

const getPlanLabel = (subscriptionType?: string) => {
  if (subscriptionType === "Monthly") return "Mesečni plan";
  if (subscriptionType === "Yearly") return "Godišnji plan";
  if (subscriptionType) return "Aktivan plan";
  return "Nema aktivnog plana";
};

const MyProfile = () => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1200px)" });
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuthPersistStore();
  const { data: subscriptionDetails, isLoading } = useSubscriptionDetails({
    isAuthenticated,
  });
  const { handleLogout } = useLogout();
  const { data: myContent, isLoading: isMyContentLoading } = useMyContent({
    isAuthenticated,
  });

  if (isLoading || isMyContentLoading) {
    return <Spinner />;
  }

  const hasSubscription = !!subscriptionDetails?.subscriptionType;

  return (
    <div className="auth my-profile">
      <div className="auth_layout">
        <div className="auth_content my-profile_content-wrap">
          <header className="auth_header">
            <h1>Moj profil</h1>
            <Paragraph variant="p2">
              Pregledaj podatke, pretplatu i podešavanja naloga.
            </Paragraph>
          </header>

          <div className="my-profile_identity">
            <UserInitials />
            <div className="my-profile_identity-text">
              <Paragraph variant="p1">
                {user?.userProfile?.fullName}
              </Paragraph>
              <span
                className={`my-profile_plan-badge ${
                  hasSubscription ? "my-profile_plan-badge--active" : ""
                }`}
              >
                {getPlanLabel(subscriptionDetails?.subscriptionType)}
              </span>
            </div>
          </div>

          <div className="my-profile_info">
            <div className="my-profile_info-item">
              <span className="my-profile_info-label">Email</span>
              <span className="my-profile_info-value">{user?.email}</span>
            </div>
            <div className="my-profile_info-item">
              <span className="my-profile_info-label">Datum rođenja</span>
              <span className="my-profile_info-value">
                {user?.userProfile?.dateOfBirth
                  ? convertFromISO8601(user.userProfile.dateOfBirth)
                  : "—"}
              </span>
            </div>
          </div>

          <div className="my-profile_actions">
            <Button
              onClick={() => navigate(ROUTES.subscription)}
              variant="primary"
              label={hasSubscription ? "Opcije pretplate" : "Odaberi plan"}
            />
            <Button
              leftIcon={<FolderIcon />}
              variant="tertiary"
              label={`Moj sadržaj (${myContent?.length ?? 0})`}
              onClick={() => navigate(ROUTES.myContent)}
            />
            <Button
              onClick={() => navigate(ROUTES.changeProfile)}
              variant="secondary"
              label="Promeni lične podatke"
            />
            <div className="my-profile_actions-row">
              <Button
                onClick={() => navigate(ROUTES.changePasswordRequest)}
                variant="tertiary"
                label="Promeni lozinku"
                leftIcon={<PasswordIcon />}
              />
              <Button
                onClick={() => navigate(ROUTES.changeEmail)}
                variant="tertiary"
                label="Promeni email"
                leftIcon={<EmailIcon />}
              />
            </div>
          </div>

          <div className="auth_form-meta auth_form-meta--footer">
            <Link
              onClick={handleLogout}
              label="Odjavi se"
              variant="tertiary"
            />
          </div>
        </div>

        {isDesktop && (
          <ProfileIlustration className="hover-float auth_illustration" />
        )}
      </div>
    </div>
  );
};

export default MyProfile;
